module.exports = __webpack_public_path__ + "img/AQ.65a5c99b.svg";